import React from "react";

import IconButton from "../iconButton";

const TooltipButton = ({ icon, text, title, onClick, disabled, className }) => (
  <IconButton
    text={text}
    icon={icon}
    title={title}
    shape="none"
    type="primary"
    onClick={onClick}
    disabled={disabled}
    className={className}
  />
);

export default TooltipButton;
